import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, r = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M4.82 14.427a.75.75 0 0 1-.043-1.06L9.713 8.01 4.785 2.63a.75.75 0 0 1 1.106-1.013l5.083 5.546a1.25 1.25 0 0 1-.002 1.692L5.88 14.383a.75.75 0 0 1-1.06.044Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  r
];
function l(d, s) {
  return e(), t("svg", n, [...c]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
